import { ModalCloseButton } from "@repo/ui/Modal/modalCloseButton";
import type { FC } from "react";
import { Dialog, Header, Popover } from "react-aria-components";
import {
  AssessmentScoreFeedbackForm,
  type AssessmentFeedbackFormValues,
} from "./form.js";

export interface AssessmentFeedbackSentimentPopoverProps {
  shouldAskForScore?: boolean;
  initialValues?: AssessmentFeedbackFormValues;
  onSubmit: (feedback: AssessmentFeedbackFormValues) => void;
}

/** Used to ask for additional information after clicking thumbs up/down button. */
export const AssessmentFeedbackSentimentPopover: FC<
  AssessmentFeedbackSentimentPopoverProps
> = (props) => {
  return (
    <Popover
      className="w-80 overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black/5 data-[entering]:animate-popover-enter data-[exiting]:animate-popover-exit"
      placement="bottom start"
    >
      <Dialog className="space-y-2 p-4">
        {({ close }) => (
          <>
            <div className="flex items-center justify-between">
              <Header
                slot="title"
                className="text-lg font-semibold text-foreground"
              >
                Thank you for your feedback!
              </Header>
              <ModalCloseButton />
            </div>

            <AssessmentScoreFeedbackForm
              shouldHideSubmitWhenUnchanged
              shouldAskForScore={props.shouldAskForScore}
              initialValues={props.initialValues}
              onSubmit={(values) => {
                props.onSubmit(values);
                close();
              }}
            />
          </>
        )}
      </Dialog>
    </Popover>
  );
};
